export const createSignaturePlaceholder = (mode, action, signature) => {
  let params = ['username'];

  if (mode === 'signature' && action === 'update' && signature) {
    params = [...new Set(signature?.originalParams)].reduce(
      (visible, item) => (item.hide ? visible : [...visible, item.name]),
      [params]
    );
  }

  // Add trailing comma for single column to avoid parse error:
  return params.length === 1 ? params.join(',') + ',' : params.join(',');
};

export const createSignatureTemplate = (signature) => {
  const code = `[[${signature?.sigcode || '#'}]]`;

  return (
    `${code}\n` +
    signature?.params
      .map((item) => !item.hide && `  ${item.name}: {{${item.name}}}`)
      .filter(Boolean)
      .join('\n') +
    `\n${code}`
  );
};

export const getBannerName = (bannerUrl) => {
  try {
    const url = new URL(bannerUrl);
    const aname = url.searchParams.get('aname');

    return aname;
  } catch (e) {
    return undefined;
  }
};
